var map = {
	"./angular.png": 8754,
	"./asp.net.png": 3240,
	"./bootstrap.png": 440,
	"./css.png": 2255,
	"./elixir.png": 9409,
	"./go.png": 2568,
	"./html.png": 2176,
	"./java.png": 2823,
	"./javascript.png": 7318,
	"./jquery.png": 8746,
	"./magento.png": 1845,
	"./mysql.png": 4575,
	"./nextjs.svg": 1823,
	"./node.js.png": 5261,
	"./php.png": 4768,
	"./postgresql.png": 3685,
	"./python.png": 6989,
	"./react-native.png": 7364,
	"./react.png": 2866,
	"./silex.png": 854,
	"./sql.png": 1920,
	"./typescript.png": 961,
	"./wordpress.png": 4780
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4744;